import React from "react";
import { Link } from "react-router-dom";
import articles from "../../data/homeArticles.json";
import { trackCTAClick } from "../../utils/analytics";
import "../../styles/Home5.css";

// Replaces MainArticle on the homepage.
//
// Two things are deliberately preserved from the component it replaces:
//   1. The admin's homepage curation. The build step picks articles by
//      home_featured / home_rank first, exactly as MainArticle did at runtime,
//      so editors keep control of what appears here.
//   2. The internal-link path from the homepage into /learn, which is the
//      Library's main discovery route and would have been lost by simply
//      deleting the old section.
//
// Unlike the old component this needs no Supabase call at page load — the
// nightly build bakes it, same as every other homepage section.

const LibrarySection = () => {
  if (!articles.length) return null;

  return (
    <section className="sv-dark sv-section library">
      <div className="sv-wrap">
        <h2 className="sv-h2 sv-center library__title">From the Library</h2>
        <p className="sv-body sv-center library__intro">
          Longer reads on plants, evidence and how to think about both.
        </p>

        <div className="sv-grid-3">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/learn/post/${a.slug}`}
              className="sv-card sv-card--link library__card"
              onClick={() =>
                trackCTAClick("home_library_article", "home-library")
              }
            >
              {a.hero_image_url && (
                <div className="sv-card__media library__media">
                  <img src={a.hero_image_url} alt="" loading="lazy" />
                </div>
              )}
              {a.category && <span className="library__cat">{a.category}</span>}
              <h3 className="sv-h4 library__card-title">{a.title}</h3>
              {a.summary && (
                <p className="sv-body library__summary">{a.summary}</p>
              )}
              <span className="library__more">Read →</span>
            </Link>
          ))}
        </div>

        <p className="sv-center library__all">
          <Link
            to="/learn"
            onClick={() => trackCTAClick("home_library_all", "home-library")}
          >
            All articles →
          </Link>
        </p>
      </div>
    </section>
  );
};

export default LibrarySection;
